import Workflows from "@/routes/workspace/workflows.tsx";

export default function ScheduledMessages() {
  return <Workflows newDesign={true} />;
}
